import Swiper from "swiper";
import {createSwiper} from "../utils/swiper";

interface CardsCoverImageSliderConfig {
	selector?: string;
	options: {
		delay?: number;
	}
}

export const CardsCoverImageSlider = {
	delay: 5000 as number,
	swiper: null as Swiper | null,
	selector: null as string | null,

	init(config?: CardsCoverImageSliderConfig): void {
		this.selector = config?.selector ?? '.wv-cards-cover-image__swiper';

		if (config?.options?.delay) {
			this.delay = config.options.delay;
		}

		this.bindClass();
		this.bindEvents();
		this.handleResize();
	},

	bindClass(): void {
		this.handleResize = this.handleResize.bind(this);
		this.initSwiper = this.initSwiper.bind(this);
		this.destroySwiper = this.destroySwiper.bind(this);
	},

	bindEvents(): void {
		window.addEventListener('resize', this.handleResize.bind(this));
	},

	handleResize(): void {
		const isMobile = window.innerWidth < 1024;

		if (isMobile && !this.swiper) {
			this.initSwiper();
		}
		if (!isMobile && this.swiper) {
			this.destroySwiper();
		}
	},

	initSwiper(): void {
		if (!this.selector) {
			return;
		}

		this.swiper = createSwiper(this.selector, 'wv-card', {
			allowTouchMove: true,
			autoHeight: true,
			autoplay: {
				delay: this.delay,
				pauseOnMouseEnter: true
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: 8,
				},
				480: {
					slidesPerView: 2,
					spaceBetween: 16,
				},
				768: {
					slidesPerView: 3,
					spaceBetween: 24,
				},
			},
			centeredSlides: true,
			direction: "horizontal",
			loop: false,
			mousewheel: false
		});
	},

	destroySwiper(): void {
		this.swiper?.destroy(true, true);
		this.swiper = null;
	}
};
